import { createSelector } from 'reselect';
import { initialState } from './../../reducers/Recent/reducer';

const selectData = (state: any) => state.recent || initialState;

export const makeRecent = () =>
  createSelector([selectData], recent => recent.recent);

export const favoriteError = () =>
  createSelector([selectData], recent => {
    return recent.error;
  });
